export enum ComboBoxMode {
    Single = 'single',
    Multi = 'multi',
}
